/* One navigation tree shared by desktop and mobile. */
(() => {
  const header = document.querySelector('.sb-header');
  if (!header) return;
  const trigger = header.querySelector('.sb-menu-toggle');
  const nav = header.querySelector('#SideBMenu');
  const close = header.querySelector('.sb-menu-close');
  const backdrop = header.querySelector('.sb-menu-backdrop');
  const mobile = matchMedia('(max-width: 989px)');
  let open = false;
  let previousOverflow = '';
  function setOpen(value, restoreFocus = true) {
    const next = value && mobile.matches;
    if (next === open) return;
    open = next;
    header.toggleAttribute('data-menu-open', open);
    trigger.setAttribute('aria-expanded', String(open));
    backdrop.hidden = !open;
    if (open) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      nav.setAttribute('role', 'dialog');
      nav.setAttribute('aria-modal', 'true');
      close.focus();
    } else {
      document.body.style.overflow = previousOverflow;
      nav.removeAttribute('role');
      nav.removeAttribute('aria-modal');
      if (restoreFocus) trigger.focus();
    }
  }
  trigger.addEventListener('click', () => setOpen(!open));
  close.addEventListener('click', () => setOpen(false));
  backdrop.addEventListener('click', () => setOpen(false));
  nav.addEventListener('click', e => { if (e.target.closest('a')) setOpen(false, false); });
  document.addEventListener('keydown', e => {
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); setOpen(false); }
    if (e.key !== 'Tab') return;
    const items = [...nav.querySelectorAll('a,button,summary')].filter(el => el.getClientRects().length);
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !nav.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !nav.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });
  mobile.addEventListener('change', () => setOpen(false, false));
})();
